'use client'

import { Button } from 'flowbite-react'
import { useEffect } from 'react'

export default function EventError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Error loading event:', error)
  }, [error])

  return (
    <div className="min-h-screen flex bg-gray-900">
      <div className="m-auto max-w-lg flex flex-col rounded-lg bg-white px-16 py-12 gap-6">
        <h1 className="text-2xl text-gray-900 leading-tight font-semibold text-center">
          We couldn&apos;t load this page
        </h1>
        <p className="text-sm text-gray-900 text-center">
          Something went wrong while loading this event. This is usually
          temporary — please try again.
        </p>
        <Button className="mt-4 mx-auto" color="dark" onClick={reset}>
          Try Again
        </Button>
      </div>
    </div>
  )
}
